import * as types from "../../actions/userSegment/types";

const initialState = {
  isFetching: false,
  isLoaded: false,
  isFetchingOrganizations: false,
  isFetchingOrganizationsForbidden: false,
  isFetchingGroups: false,
  isFetchingUsers: false,
  isLoadedOrganizations: false,
  isLoadedGroups: false,
  isLoadedUsers: false,
  isSaving: false,
  hasFetchError: false,
  name: "",
  savedName: "",
  userType: null,
  tags: [],
  savedTags: [],
  organizations: [],
  savedOrganizations: [],
  groups: [],
  savedGroups: [],
  builtIn: false,
  users: [],
  userCount: 0,
  userPageCount: 0,
};

export default function userSegment(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_USER_SEGMENT_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
        isLoaded: false,
        hasFetchError: false,
      });
    }
    case types.FETCH_USER_SEGMENT_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: true,
        name: action.userSegment.name,
        savedName: action.userSegment.name,
        tags: action.userSegment.tags,
        savedTags: action.userSegment.tags,
        builtIn: action.userSegment.built_in,
        userType: action.userSegment.user_type,
      });
    }
    case types.FETCH_USER_SEGMENT_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: false,
        hasFetchError: true,
      });
    }
    case types.FETCH_USER_SEGMENT_ORGANIZATIONS_REQUEST: {
      return Object.assign({}, state, {
        isFetchingOrganizations: true,
        isLoadedOrganizations: false,
        isFetchingOrganizationsForbidden: false,
      });
    }
    case types.FETCH_USER_SEGMENT_ORGANIZATIONS_FAILURE: {
      return Object.assign({}, state, {
        isFetchingOrganizations: false,
        isLoadedOrganizations: false,
        isFetchingOrganizationsForbidden: action.error.status === 403,
      });
    }
    case types.FETCH_USER_SEGMENT_ORGANIZATIONS_SUCCESS: {
      let deletedCount = 0;
      const organizations = action.requestedIds.map(id => {
        const organization = action.organizations.find(
          organization => organization.id === id
        );

        return organization
          ? Object.assign({}, organization, { deleted: false })
          : {
              id,
              name: `Deleted organization ${++deletedCount}`,
              deleted: true,
            };
      });

      return Object.assign({}, state, {
        organizations,
        isFetchingOrganizations: false,
        isLoadedOrganizations: true,
        savedOrganizations: organizations,
      });
    }
    case types.FETCH_USER_SEGMENT_GROUPS_REQUEST: {
      return Object.assign({}, state, {
        isFetchingGroups: true,
        isLoadedGroups: false,
      });
    }
    case types.FETCH_USER_SEGMENT_GROUPS_SUCCESS: {
      let deletedCount = 0;
      const groups = action.groups.map(
        group =>
          group.deleted
            ? Object.assign({}, group, {
                name: `Deleted group ${++deletedCount}`,
              })
            : group
      );

      return Object.assign({}, state, {
        groups,
        isFetchingGroups: false,
        isLoadedGroups: true,
        savedGroups: groups,
      });
    }
    case types.FETCH_USERS_REQUEST: {
      return Object.assign({}, state, {
        isFetchingUsers: true,
        isLoadedUsers: false,
      });
    }
    case types.FETCH_USERS_SUCCESS: {
      // Intersect user segment's properties with user's properties
      const usersWithFilteredProperties = action.users.map(user => {
        const userOrganizationIds = user.organizations.map(({ id }) => id);
        const userGroupIds = user.groups.map(({ id }) => id);

        const tags = state.tags.filter(tag => user.tags.includes(tag));
        const organizations = state.organizations.filter(({ id }) =>
          userOrganizationIds.includes(id)
        );
        const groups = state.groups.filter(({ id }) =>
          userGroupIds.includes(id)
        );

        return {
          ...user,
          tags,
          organizations,
          groups,
        };
      });

      return Object.assign({}, state, {
        isFetchingUsers: false,
        isLoadedUsers: true,
        users: usersWithFilteredProperties,
        userCount: action.count,
        userPageCount: action.pageCount,
      });
    }
    case types.CHANGE_NAME: {
      return Object.assign({}, state, {
        name: action.name,
      });
    }
    case types.CHANGE_USER_TYPE: {
      return Object.assign({}, state, {
        userType: action.userType,
      });
    }
    case types.CHANGE_TAG: {
      const tags = [...state.tags];
      const indexToReplace = tags.findIndex(tag => tag === action.originalTag);

      if (indexToReplace < 0) {
        return state;
      }

      tags.splice(indexToReplace, 1, action.newTag);

      return Object.assign({}, state, {
        tags,
      });
    }
    case types.ADD_TAG: {
      return Object.assign({}, state, {
        tags: [...state.tags, action.tag],
      });
    }
    case types.REMOVE_TAG: {
      return Object.assign({}, state, {
        tags: state.tags.filter(tag => tag !== action.tag),
      });
    }

    case types.CHANGE_ORGANIZATION: {
      const organizations = [...state.organizations];
      const indexToReplace = organizations.findIndex(
        organization => organization.id === action.originalOrganization.id
      );

      if (indexToReplace < 0) {
        return state;
      }

      organizations.splice(indexToReplace, 1, action.newOrganization);

      return Object.assign({}, state, {
        organizations,
      });
    }
    case types.ADD_ORGANIZATION: {
      return Object.assign({}, state, {
        organizations: [...state.organizations, action.organization],
      });
    }
    case types.REMOVE_ORGANIZATION: {
      return Object.assign({}, state, {
        organizations: state.organizations.filter(
          organization => organization.id !== action.organization.id
        ),
      });
    }

    case types.CHANGE_GROUP: {
      const groups = [...state.groups];
      const indexToReplace = groups.findIndex(
        group => group.id === action.originalGroup.id
      );

      if (indexToReplace < 0) {
        return state;
      }

      groups.splice(indexToReplace, 1, action.newGroup);

      return Object.assign({}, state, {
        groups,
      });
    }
    case types.ADD_GROUP: {
      return Object.assign({}, state, {
        groups: [...state.groups, action.group],
      });
    }
    case types.REMOVE_GROUP: {
      return Object.assign({}, state, {
        groups: state.groups.filter(group => group.id !== action.group.id),
      });
    }
    case types.SAVE_USER_SEGMENT_REQUEST: {
      return Object.assign({}, state, { isSaving: true });
    }
    case types.SAVE_USER_SEGMENT_SUCCESS: {
      return Object.assign({}, state, {
        isSaving: false,
        savedName: state.name,
        savedTags: state.tags,
        savedGroups: state.groups,
        savedOrganizations: state.organizations,
      });
    }
    case types.CREATE_USER_SEGMENT_REQUEST: {
      return Object.assign({}, state, { isSaving: true });
    }
    case types.CREATE_USER_SEGMENT_SUCCESS: {
      return Object.assign({}, state, {
        isSaving: false,
        savedName: state.name,
        savedTags: state.tags,
        savedGroups: state.groups,
        savedOrganizations: state.organizations,
      });
    }
    case types.SAVE_USER_SEGMENT_FAILURE: {
      return Object.assign({}, state, { isSaving: false });
    }
    case types.RESET_USER_SEGMENT: {
      return Object.assign({}, state, {
        isLoaded: false,
        userType: null,
        name: "",
        savedName: "",
        tags: [],
        savedTags: [],
        groups: [],
        savedGroups: [],
        organizations: [],
        savedOrganizations: [],
        users: [],
        userCount: 0,
        userPageCount: 0,
      });
    }

    case types.RESET_USER_SEGMENT_ATTRIBUTES: {
      return Object.assign({}, state, {
        tags: [],
        savedTags: [],
        groups: [],
        savedGroups: [],
        organizations: [],
        savedOrganizations: [],
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userSegment/index.js